var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "fill-rule": "evenodd",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "2",
        "clip-rule": "evenodd",
        viewBox: "0 0 32 32",
        id: "Paper",
      },
    },
    [
      _c("path", {
        attrs: {
          fill: "url(#_Linear1)",
          d: "M2,31l28,0c0.552,0 1,-0.448 1,-1l0,-18c0,-0.552 -0.448,-1 -1,-1l-6,0l-0,-4.021c-0.004,-0.179 -0.055,-0.346 -0.14,-0.489l-0.079,-0.115l-4,-5c-0.19,-0.237 -0.477,-0.375 -0.781,-0.375l-10,-0c-0.552,-0 -1,0.448 -1,1l0,9l-6,0c-0.552,0 -1,0.448 -1,1l-0,18c0,0.552 0.448,1 1,1Zm21,-12l-0,6c-0,0.552 0.448,1 1,1c0.552,0 1,0.448 1,1c-0,0.552 -0.448,1 -1,1c-1.657,-0 -3,-1.343 -3,-3l0,-6l-2,0l0,8c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-8l-2,0l0,8c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-8l-2,0l-0,6c0,1.657 -1.343,3 -3,3c-0.552,0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1c0.552,-0 1,-0.448 1,-1l0,-6l-5,0l-0,10l24,0l-0,-10l-5,0Zm-13,-8l12,0l-0,-3l-4,0c-0.552,-0 -1,-0.448 -1,-1l0,-4l-7,-0l-0,8Zm9,-5l1.919,0l-1.919,-2.399l0,2.399Z",
        },
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "_Linear1",
                x1: "0",
                x2: "1",
                y1: "0",
                y2: "0",
                gradientTransform: "matrix(0 29.833 -29.8329 0 19.281 1)",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                staticClass: "stopColorffa691 svgShape",
                attrs: { offset: "0", "stop-color": "#f79513" },
              }),
              _vm._v(" "),
              _c("stop", {
                staticClass: "stopColorfd3a84 svgShape",
                attrs: { offset: "1", "stop-color": "#fb8d00" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }